import { z } from 'zod'

export const schema = z.object({
  averageReviewScore: z.number(),
  bestScore: z.number().int(),
  countScore: z.number().int(),
})

export type schemaType = z.infer<typeof schema>
